import { useQuery } from "@tanstack/react-query";
import { format, startOfDay } from "date-fns";
import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { instance2 } from "src/components/utils/axiosInstance";

const getCustomersByDate = async ({ kitchenId, dateString }) => {
  if (!kitchenId || !dateString) return null;
  const res = await instance2.get(
    `/customers/kitchen/${kitchenId}/${dateString}`,
  );
  return res.data;
};

export const useGetCustomersData = () => {
  const kitchenId = useMemo(() => localStorage.getItem("kitchenId"), []);
  const location = useLocation();
  const dateString = useMemo(() => {
    const queryParams = new URLSearchParams(location.search);
    const dateParam = queryParams.get("date");
    const date = dateParam
      ? startOfDay(new Date(dateParam))
      : startOfDay(new Date());
    return format(date, "yyyy-MM-dd");
  }, [location.search]);

  return useQuery({
    queryKey: ["customers-data", { kitchenId, dateString }],
    queryFn: () => getCustomersByDate({ kitchenId, dateString }),
    enabled: !!kitchenId,
  });
};
